import { render, staticRenderFns } from "./work_item_children_load_more.vue?vue&type=template&id=01997f19"
import script from "./work_item_children_load_more.vue?vue&type=script&lang=js"
export * from "./work_item_children_load_more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports